export { default } from './EventCard';
